var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 3.375H14.25V1.5C14.25 0.672656 13.5773 0 12.75 0H5.25C4.42266 0 3.75 0.672656 3.75 1.5V3.375H0.75C0.335156 3.375 0 3.71016 0 4.125V4.875C0 4.97813 0.084375 5.0625 0.1875 5.0625H1.60312L2.18203 17.3203C2.21953 18.1195 2.88047 18.75 3.67969 18.75H14.3203C15.1219 18.75 15.7805 18.1219 15.818 17.3203L16.3969 5.0625H17.8125C17.9156 5.0625 18 4.97813 18 4.875V4.125C18 3.71016 17.6648 3.375 17.25 3.375ZM12.5625 3.375H5.4375V1.6875H12.5625V3.375Z",
    fill: "#B91C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete2);
export default __webpack_public_path__ + "static/media/delete-2.05282d32fda016a94d31e0c9dfb0f73b.svg";
export { ForwardRef as ReactComponent };